import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ArvoreArquivoService {

  constructor() { }

  public montarArvore(lista: any[], paiId: string | null): any[] {
    return lista
      .filter(a => {
        const isPaiRoot = !paiId || paiId === '00000000-0000-0000-0000-000000000000';
        const isItemRoot = !a.arquivoPaiId || a.arquivoPaiId === '00000000-0000-0000-0000-000000000000';

        if (isPaiRoot && isItemRoot) return true;
        if (isPaiRoot || isItemRoot) return false;

        return a.arquivoPaiId.toLowerCase() === paiId.toLowerCase();
      })
      .map(a => {
        const node = { ...a, arquivos: [] };
        if (node.ehPasta) {
          node.arquivos = this.montarArvore(lista, node.id);
        }
        return node;
      });
  }

  public encontrarPastaNaArvore(arvore: any[], id: string): any {
    if (!id || id === '00000000-0000-0000-0000-000000000000') return null;
    const safeId = id.toLowerCase();

    for (const node of arvore) {
      if (node.id && node.id.toLowerCase() === safeId) return node;
      if (node.arquivos && node.arquivos.length > 0) {
        const found = this.encontrarPastaNaArvore(node.arquivos, id);
        if (found) return found;
      }
    }
    return null;
  }

  public getQuantidadeApenasArquivos(item: any): number {
    if (!item || !item.arquivos || !Array.isArray(item.arquivos)) return 0;

    let count = 0;
    item.arquivos.forEach((filho: any) => {
      if (!filho.ehPasta) {
        count++;
      } else {
        count += this.getQuantidadeApenasArquivos(filho);
      }
    });

    return count;
  }
}
